export default __webpack_public_path__ + "static/media/polk_p_rare_mini.969f58e3.png";